// bluaIQ — Daily Log / Bitácora language-safe field selection (pure helper)
//
// Switching language must NEVER feel like data loss. A daily log stores each
// free-text field in two columns (e.g. workPerformed / workPerformedEs). Content
// is only ever written into the column for the language the author was using, so
// a Spanish-only entry leaves `workPerformed` (EN) empty. The view must therefore
// fall back to whichever language actually holds the stored text:
//   • Show the requested language if it has non-empty text.
//   • Else fall back to the other language's stored text (the original source).
//   • Else return '' (truly empty → the section's guard hides it).
//
// This is display-only: it never overwrites stored data and never auto-translates.
// Kept in a dependency-free module so it can be imported and unit-tested directly
// (DailyLogModule.tsx pulls in React/Clerk and is not import-safe under node:test).
export function localizedLogField(en?: string | null, es?: string | null, isEs?: boolean): string {
  const primary = isEs ? es : en
  const fallback = isEs ? en : es
  if (primary && primary.trim()) return primary
  if (fallback && fallback.trim()) return fallback
  return ''
}
